module.exports = "<div class=\"map-popup-item\">\n    {{name}}\n</div>";